const isFutureUtil = (time: string | number): boolean => {
  const now = new Date().getTime();
  const timeToCompare = new Date();
  const [hour, minute] = time.toString().split(':');

  timeToCompare.setHours(parseInt(hour, 10), parseInt(minute, 10));

  return timeToCompare.getTime() > now;
};

export default isFutureUtil;
